import { c as _c } from "react/compiler-runtime";
import { Loader2, Sparkles, WandSparklesIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
type GenerationType = 'skybox' | 'texture' | 'image' | '3d';
interface GenerateButtonProps {
  activeTab: GenerationType;
  isGenerating: boolean;
  isLoadingImageModelInputs: boolean;
  textureGenerateDisableReason: string | null;
  imageGenerateDisableReason: string | null;
  is3DGenerateDisabled: boolean;
  model3DGenerateDisableReason: string | null;
  onGenerate: () => void;
}
export const GenerateButton = t0 => {
  const $ = _c(34);
  const {
    activeTab,
    isGenerating,
    isLoadingImageModelInputs,
    textureGenerateDisableReason,
    imageGenerateDisableReason,
    is3DGenerateDisabled,
    model3DGenerateDisableReason,
    onGenerate
  } = t0;
  let t1;
  if ($[0] !== isGenerating) {
    t1 = {
      label: "Generate Skybox",
      loadingLabel: "Generating...",
      icon: WandSparklesIcon,
      disabled: isGenerating,
      disableReason: null as string | null
    };
    $[0] = isGenerating;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!textureGenerateDisableReason;
  let t3;
  if ($[2] !== t2 || $[3] !== textureGenerateDisableReason) {
    t3 = {
      label: "Generate Texture",
      loadingLabel: "Generating...",
      icon: WandSparklesIcon,
      disabled: t2,
      disableReason: textureGenerateDisableReason
    };
    $[2] = t2;
    $[3] = textureGenerateDisableReason;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isLoadingImageModelInputs ? "Loading Model..." : "Generating...";
  const t5 = !!imageGenerateDisableReason;
  let t6;
  if ($[5] !== imageGenerateDisableReason || $[6] !== t4 || $[7] !== t5) {
    t6 = {
      label: "Generate Image",
      loadingLabel: t4,
      icon: WandSparklesIcon,
      disabled: t5,
      disableReason: imageGenerateDisableReason
    };
    $[5] = imageGenerateDisableReason;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = isGenerating || is3DGenerateDisabled;
  let t8;
  if ($[9] !== model3DGenerateDisableReason || $[10] !== t7) {
    t8 = {
      label: "Generate 3D Model",
      loadingLabel: "Generating 3D Model...",
      icon: Sparkles,
      disabled: t7,
      disableReason: model3DGenerateDisableReason
    };
    $[9] = model3DGenerateDisableReason;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t6 || $[15] !== t8) {
    t9 = {
      skybox: t1,
      texture: t3,
      image: t6,
      "3d": t8
    };
    $[12] = t1;
    $[13] = t3;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const config = t9[activeTab];
  const Icon = config.icon;
  const showLoading = isGenerating || activeTab === "image" && isLoadingImageModelInputs;
  const t10 = isGenerating ? "on" : "off";
  let t11;
  if ($[17] !== Icon || $[18] !== config.label || $[19] !== config.loadingLabel || $[20] !== showLoading) {
    t11 = showLoading ? <><Loader2 className="mr-2 size-4 animate-spin" />{config.loadingLabel}</> : <><Icon className="mr-2 size-4" />{config.label}</>;
    $[17] = Icon;
    $[18] = config.label;
    $[19] = config.loadingLabel;
    $[20] = showLoading;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== config.disabled || $[23] !== onGenerate || $[24] !== t10 || $[25] !== t11) {
    t12 = <Button variant="default" size="default" onClick={onGenerate} disabled={config.disabled} className="w-full h-11 text-sm font-semibold text-white hover:text-white active:text-white bg-linear-to-r from-primary to-primary/80 hover:from-primary/80 hover:to-primary/60 active:from-primary/70 active:to-primary/50 shadow-md transition-colors duration-200" data-state={t10}>{t11}</Button>;
    $[22] = config.disabled;
    $[23] = onGenerate;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const button = t12;
  if (config.disableReason) {
    let t13;
    if ($[27] !== button) {
      t13 = <TooltipTrigger asChild={true}><span className="w-full">{button}</span></TooltipTrigger>;
      $[27] = button;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    let t14;
    if ($[29] !== config.disableReason) {
      t14 = <TooltipContent side="top">{config.disableReason}</TooltipContent>;
      $[29] = config.disableReason;
      $[30] = t14;
    } else {
      t14 = $[30];
    }
    let t15;
    if ($[31] !== t13 || $[32] !== t14) {
      t15 = <Tooltip>{t13}{t14}</Tooltip>;
      $[31] = t13;
      $[32] = t14;
      $[33] = t15;
    } else {
      t15 = $[33];
    }
    return t15;
  }
  return button;
};
GenerateButton.displayName = 'GenerateButton';